<script lang="ts">
    import { _ } from "svelte-i18n";
    import { FileCopyLine } from "svelte-remixicon";
    import { createPopperActions } from "svelte-popperjs";
    const [popperRef, popperContent] = createPopperActions();
    const popperOptions = {
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 8]
                }
            }
        ],
    };

    export let text = undefined;
    export let title = undefined;
    export let title_style = '';
    export let link = undefined;
    export let link_type = undefined;
    export let link_style = '';
    export let copy = false;

    let tooltip: boolean;

    function addToClipboard() {
        navigator.clipboard.writeText(this.innerText);
        tooltip = true;
        setTimeout(() => {
            tooltip = false;
        }, 2000);
    }
</script>

{#if text !== undefined && text !== ''}
    <div class="flex flex-col md:flex-row text-base">
        {#if title !== undefined}
            <div class="w-12/12 md:w-6/12 font-bold md:font-normal {title_style}">{title}</div>
        {/if}
        <div class="{title === undefined ? 'w-12/12' : 'w-12/12 md:w-6/12'}">
            {#if link !== undefined}
                <a class="underline {link_style}" target="_blank" href="{link_type === undefined ? '' : link_type + ':'}{link}">
                    {text}
                </a>
            {:else}
                {#if copy}
                    <div class="flex items-center cursor-pointer" on:click={addToClipboard}>
                        {#if tooltip}
                            <div id="tooltip" use:popperContent={popperOptions} on:click={() => {tooltip = false}}
                                 role="tooltip" class="inline-block absolute z-10 py-1 px-2 mb-16 text-sm font-small text-white bg-darkblue rounded-lg tooltip">
                                {$_('copy')}
                                <div id="arrow" data-popper-arrow></div>
                            </div>
                        {/if}
                        <span class="pr-1">{text}</span><span><FileCopyLine /></span>
                    </div>
                {:else}
                    <span>{text}</span>
                {/if}
            {/if}
        </div>
    </div>
{/if}

<style windi:preflights>
</style>
